module.exports = __webpack_public_path__ + "static/media/sad-face.bfa8fafd.png";